module.exports = __webpack_public_path__ + "static/media/kinda home.bd6f9a90.webp";